import { useNavigate } from 'react-router-dom';
import { useAuth } from '@screentone/addon-auth-wrapper';
import { Button, IconCode2, Wrapper } from '@screentone/core';

import { AllessehCollectionType, ExternalCollectionItem } from 'data/generated/graphql';

interface EditCollectionProps {
  collection: ExternalCollectionItem;
}

export const EditCollection = ({ collection }: EditCollectionProps) => {
  const { currentProperty } = useAuth();
  const navigate = useNavigate();

  const handleGoToCollection = () => {
    const idCreatedUtc = `${collection.metadata.id}_${collection.metadata.createdUtc}`;

    const { collectionType, publicationKey } = collection.metadata;

    if (collectionType === AllessehCollectionType.CurationOffPlatform) {
      navigate(`/${publicationKey}/off-platform/${idCreatedUtc}`);

      return;
    }

    navigate(`/${currentProperty ?? ''}/collections/${idCreatedUtc}`);
  };

  return (
    <Wrapper>
      <Button tertiary icon={IconCode2} onClick={handleGoToCollection}>
        Edit collection
      </Button>
    </Wrapper>
  );
};
